export const ratingsColors = {
  five: '#658E12',
  four: '#8BB626',
  three: '#FFBE01',
  two: '#F1A200',
  one: '#D5001C'
}

export const ratingsKeys = [5, 4, 3, 2, 1]

export const headlinesAllSingleRatings = ['Applikation', 'Bewertung', 'Kommentar', 'Datum']
export const headlinesAppList = ['Applikation', 'Bewertung', 'Anzahl Ratings']
export const headlinesAppWithSubApps = ['Bereiche', 'Anzahl Ratings']

export const headlinesDepartmentList = ['Abteilungen', 'Bewertung', 'Anzahl Ratings', 'Anzahl Apps']

export function getValues(array: any) {
  const ratingsAllStars = {
    5: getCount(5, array),
    4: getCount(4, array),
    3: getCount(3, array),
    2: getCount(2, array),
    1: getCount(1, array)
  }

  const ratingsTotal =
    ratingsAllStars[5] + ratingsAllStars[4] + ratingsAllStars[3] + ratingsAllStars[2] + ratingsAllStars[1]

  const ratingsAvg: any = (
    (1 * ratingsAllStars[1] +
      2 * ratingsAllStars[2] +
      3 * ratingsAllStars[3] +
      4 * ratingsAllStars[4] +
      5 * ratingsAllStars[5]) /
    ratingsTotal
  ).toFixed(2)

  const newRatingsAvg = isNaN(ratingsAvg) ? 0 : ratingsAvg

  const ratingsPercentages = {
    5: getPercentage(ratingsAllStars[5], ratingsTotal),
    4: getPercentage(ratingsAllStars[4], ratingsTotal),
    3: getPercentage(ratingsAllStars[3], ratingsTotal),
    2: getPercentage(ratingsAllStars[2], ratingsTotal),
    1: getPercentage(ratingsAllStars[1], ratingsTotal)
  }

  return { ratingsAllStars, ratingsTotal, newRatingsAvg, ratingsPercentages }
}

function getCount(number: number, array: any) {
  if (array) {
    if (array.length === 0) {
      return 0
    }
    for (let i = 0; i < array.length; i++) {
      if (array[i].rating === number) {
        return array[i].count
      }
      if (i === array.length) {
        return 0
      }
    }
  }
  return 0
}

function getPercentage(num: number, total: number) {
  if (total === 0) {
    return 0
  }
  return ((num / total) * 100).toFixed(0)
}
